import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deputation-authorization-form',
  templateUrl: './deputation-authorization-form.component.html',
  styleUrls: ['./deputation-authorization-form.component.css']
})
export class DeputationAuthorizationFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/deputaion/deputation-authorization/deputation-authorization-form/deputation-authorization-form.component.ts